import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Fact from './Fact';

import i from './FactImageThumbnail.css'; // eslint-disable-line css-modules/no-unused-class

function HoC(props) {
  return (
    <Fact
      id="kostrad"
      className="clearfix"
      title="Livsmedelsverkets kostråd"
      {...props}
    >
      <p className={i.root}>
        <a
          rel="noopener noreferrer"
          href="https://www.livsmedelsverket.se/globalassets/matvanor-halsa-miljo/kostrad-matvanor/vuxna/kostraed_webb.pdf"
          target="_blank"
        >
          <img
            className={i.image}
            alt="Hitta ditt sätt"
            src="https://s3-eu-west-1.amazonaws.com/kostradsguiden/hitta-ditt-satt.jpg"
          />
        </a>
      </p>
      <p>
        {'Mer information och inspiration om kostråden hittar du på '}
        <a
          rel="noopener noreferrer"
          href="https://www.livsmedelsverket.se/matvanor-halsa--miljo/kostrad-och-matvanor/rad-om-bra-mat-hitta-ditt-satt"
          target="_blank"
        >
          {'Livsmedelsverkets hemsida'}
        </a>
        {' och i broschyren '}
        <a
          rel="noopener noreferrer"
          href="https://www.livsmedelsverket.se/globalassets/matvanor-halsa-miljo/kostrad-matvanor/vuxna/kostraed_webb.pdf"
          target="_blank"
        >
          {'Hitta ditt sätt'}
        </a>
        {'.'}
      </p>
    </Fact>
  );
}

export default withStyles(i)(HoC);



// WEBPACK FOOTER //
// ./src/components/Fact/FactLivsmedelverketsKostrad.js